/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import Hidden from '../../../Hidden';
import cx from 'classnames';
import styles from './LeftColumnSkeleton.module.scss';
import { Skeleton } from '@az/starc-ui';

export default function LeftColumnSkeleton() {
  const skeletonThumbnails = Array(8).fill(1);
  return (
    <div className={styles.container} data-testid="product-availability-info-left-skeleton-v2">
      <div className={styles.mainImage}>
        <Skeleton width="100%" height="100%" />
      </div>
      <Hidden className={cx(styles.thumbnailContainer, styles.imageSlider)} mdUp>
        <Skeleton width="117px" height="17px" />
      </Hidden>
      <Hidden className={cx(styles.thumbnailContainer, styles.thumbnailContainerImages)} smDown>
        {skeletonThumbnails.map((_, index) => (
          <Skeleton key={index} width="52px" height="52px" className={styles.thumbNailImage} />
        ))}
      </Hidden>
    </div>
  );
}
